import { render, staticRenderFns } from "./ViewTeacherSummary.vue?vue&type=template&id=0f8d33a9&scoped=true&"
import script from "./ViewTeacherSummary.vue?vue&type=script&lang=js&"
export * from "./ViewTeacherSummary.vue?vue&type=script&lang=js&"
import style0 from "./ViewTeacherSummary.vue?vue&type=style&index=0&id=0f8d33a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d33a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardSubtitle,VCardTitle,VCol,VDivider,VRow})
